import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp, FiArrowRight, FiBookOpen, FiTrendingUp, FiCalendar, FiUsers, FiStar, FiClock, FiMapPin } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";

class ExhibitionsAndActivities extends Component {
    render() {
        return (
            <React.Fragment>
                <PageHelmet pageTitle='นิทรรศการและกิจกรรม' />
                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.webp" />

                {/* Hero Section */}
                <div className="hero-section" style={{
                    background: 'linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url("/assets/images/singha/floor1/IMG_7829.webp")',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    minHeight: '60vh',
                    display: 'flex',
                    alignItems: 'center',
                    position: 'relative'
                }}>
                    <div className="container">
                        <div className="row justify-content-center text-center">
                            <div className="col-lg-8">
                                <h1 style={{
                                    color: 'white',
                                    fontSize: '4rem',
                                    fontWeight: 'bold',
                                    marginBottom: '1.5rem',
                                    textShadow: '2px 2px 4px rgba(0,0,0,0.7)'
                                }}>
                                    นิทรรศการและกิจกรรม
                                </h1>
                                <p style={{
                                    color: 'white',
                                    fontSize: '1.4rem',
                                    opacity: 0.9,
                                    textShadow: '1px 1px 2px rgba(0,0,0,0.7)',
                                    marginBottom: '2rem'
                                }}>
                                    สำรวจประวัติศาสตร์และวิถีชีวิตของชุมชนสิงห์ท่าผ่านนิทรรศการที่จัดแสดงในพิพิธภัณฑ์สิงห์ท่า
                                </p>
                                <div style={{
                                    display: 'flex',
                                    gap: '3rem',
                                    justifyContent: 'center',
                                    flexWrap: 'wrap'
                                }}>
                                    <div style={{ textAlign: 'center', flex: '1', minWidth: '150px' }}>
                                        <div style={{ fontSize: '3rem', fontWeight: 'bold', color: '#F45354', marginBottom: '0.5rem' }}>2</div>
                                        <div style={{ color: 'white', fontSize: '1.2rem', opacity: 0.9 }}>ชั้นนิทรรศการ</div>
                                    </div>
                                    <div style={{ textAlign: 'center', flex: '1', minWidth: '150px' }}>
                                        <div style={{ fontSize: '3rem', fontWeight: 'bold', color: '#F45354', marginBottom: '0.5rem' }}>9</div>
                                        <div style={{ color: 'white', fontSize: '1.2rem', opacity: 0.9 }}>ส่วนจัดแสดง</div>
                                    </div>
                                    <div style={{ textAlign: 'center', flex: '1', minWidth: '150px' }}>
                                        <div style={{ fontSize: '3rem', fontWeight: 'bold', color: '#F45354', marginBottom: '0.5rem' }}>200+</div>
                                        <div style={{ color: 'white', fontSize: '1.2rem', opacity: 0.9 }}>ปี ประวัติศาสตร์</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Exhibition Floors Section */}
                <div style={{ backgroundColor: '#f8f9fa', padding: '5rem 0' }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h2 style={{
                                    fontSize: '2.5rem',
                                    fontWeight: 'bold',
                                    color: '#242424',
                                    marginBottom: '3rem',
                                    textAlign: 'center'
                                }}>
                                    นิทรรศการถาวร
                                </h2>
                            </div>
                        </div>

                        {/* Floor Cards */}
                        <div className="row">
                            {/* Floor 1 Card */}
                            <div className="col-lg-6 col-md-12 mb-4">
                                <div style={{
                                    backgroundColor: 'white',
                                    borderRadius: '20px',
                                    overflow: 'hidden',
                                    boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                                    height: '100%',
                                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                    cursor: 'pointer'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.transform = 'translateY(-10px)';
                                    e.target.style.boxShadow = '0 30px 60px rgba(0,0,0,0.15)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = '0 20px 40px rgba(0,0,0,0.1)';
                                }}
                                onClick={() => window.location.href = '/exhibition-floor-1'}>
                                    <div style={{ height: '300px', overflow: 'hidden', position: 'relative' }}>
                                        <img 
                                            src="/assets/images/singha/floor1/IMG_7829.webp" 
                                            alt="นิทรรศการชั้น 1"
                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                        />
                                        <div style={{
                                            position: 'absolute',
                                            top: 0, left: 0, right: 0, bottom: 0,
                                            background: 'linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.7))',
                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                            opacity: 0, transition: 'opacity 0.3s ease'
                                        }}
                                        onMouseEnter={(e) => { e.target.style.opacity = '1'; }}
                                        onMouseLeave={(e) => { e.target.style.opacity = '0'; }}>
                                            <FiArrowRight style={{ color: 'white', fontSize: '2rem' }} />
                                        </div>
                                    </div>
                                    <div style={{ padding: '2rem' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1.5rem' }}>
                                            <div style={{
                                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                width: '60px', height: '60px', backgroundColor: '#F45354',
                                                borderRadius: '50%', marginRight: '1rem'
                                            }}>
                                                <FiBookOpen style={{ color: 'white', fontSize: '1.5rem' }} />
                                            </div>
                                            <h3 style={{ fontSize: '2rem', fontWeight: 'bold', color: '#242424', margin: 0 }}>
                                                ชั้นที่ 1
                                            </h3>
                                        </div>
                                        <h4 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#F45354', marginBottom: '1rem' }}>
                                            เรื่องเล่าเมืองสิงห์ท่า
                                        </h4>
                                        <p style={{ color: '#666', lineHeight: '1.6', fontSize: '1.2rem', marginBottom: '1.5rem' }}>
                                            นิทรรศการที่เล่าเรื่องราวความเป็นมาของชุมชนสิงห์ท่า ตั้งแต่ยุคก่อบ้านตั้งเมือง 
                                            จนถึงการพัฒนาสู่เมืองยศสุนทร และกลายเป็นจังหวัดยโสธรในปัจจุบัน
                                        </p>
                                        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                                            <span style={{ backgroundColor: '#f0f0f0', padding: '0.5rem 1rem', borderRadius: '20px', fontSize: '0.9rem', color: '#666' }}>
                                                4 ส่วนจัดแสดง
                                            </span>
                                            <span style={{ backgroundColor: '#f0f0f0', padding: '0.5rem 1rem', borderRadius: '20px', fontSize: '0.9rem', color: '#666' }}>
                                                โรงภาพยนตร์จำลอง
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Floor 2 Card */}
                            <div className="col-lg-6 col-md-12 mb-4">
                                <div style={{
                                    backgroundColor: 'white',
                                    borderRadius: '20px',
                                    overflow: 'hidden',
                                    boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                                    height: '100%',
                                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                    cursor: 'pointer'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.transform = 'translateY(-10px)';
                                    e.target.style.boxShadow = '0 30px 60px rgba(0,0,0,0.15)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = '0 20px 40px rgba(0,0,0,0.1)';
                                }}
                                onClick={() => window.location.href = '/exhibition-floor-2'}>
                                    <div style={{ height: '300px', overflow: 'hidden', position: 'relative' }}>
                                        <img 
                                            src="/assets/images/singha/floor2/IMG_7982.webp" 
                                            alt="นิทรรศการชั้น 2"
                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                        />
                                        <div style={{
                                            position: 'absolute',
                                            top: 0, left: 0, right: 0, bottom: 0,
                                            background: 'linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.7))',
                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                            opacity: 0, transition: 'opacity 0.3s ease'
                                        }}
                                        onMouseEnter={(e) => { e.target.style.opacity = '1'; }}
                                        onMouseLeave={(e) => { e.target.style.opacity = '0'; }}>
                                            <FiArrowRight style={{ color: 'white', fontSize: '2rem' }} />
                                        </div>
                                    </div>
                                    <div style={{ padding: '2rem' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1.5rem' }}>
                                            <div style={{
                                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                width: '60px', height: '60px', backgroundColor: '#F45354',
                                                borderRadius: '50%', marginRight: '1rem'
                                            }}>
                                                <FiTrendingUp style={{ color: 'white', fontSize: '1.5rem' }} />
                                            </div>
                                            <h3 style={{ fontSize: '2rem', fontWeight: 'bold', color: '#242424', margin: 0 }}>
                                                ชั้นที่ 2
                                            </h3>
                                        </div>
                                        <h4 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#F45354', marginBottom: '1rem' }}>
                                            วิถีชีวิตและพัฒนาการ
                                        </h4>
                                        <p style={{ color: '#666', lineHeight: '1.6', fontSize: '1.2rem', marginBottom: '1.5rem' }}>
                                            นิทรรศการที่เล่าเรื่องราววิถีชีวิตและพัฒนาการของชุมชนสิงห์ท่า 
                                            ตั้งแต่ยุคเกษตรกรรมจนถึงการค้าขายและการพัฒนาสู่เมืองสมัยใหม่
                                        </p>
                                        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                                            <span style={{ backgroundColor: '#f0f0f0', padding: '0.5rem 1rem', borderRadius: '20px', fontSize: '0.9rem', color: '#666' }}>
                                                5 ส่วนจัดแสดง
                                            </span>
                                            <span style={{ backgroundColor: '#f0f0f0', padding: '0.5rem 1rem', borderRadius: '20px', fontSize: '0.9rem', color: '#666' }}>
                                                วิถีชีวิตชุมชน
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Call to Action */}
                <div style={{ backgroundColor: '#242424', padding: '5rem 0' }}>
                    <div className="container">
                        <div className="row justify-content-center text-center">
                            <div className="col-lg-8">
                                <h2 style={{ color: 'white', fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '1.5rem' }}>
                                    เยี่ยมชมพิพิธภัณฑ์สิงห์ท่า
                                </h2>
                                <p style={{ color: '#ccc', fontSize: '1.5rem', marginBottom: '2rem', lineHeight: '1.6' }}>
                                    เปิดให้เข้าชมทุกวันอังคาร-อาทิตย์ เวลา 9.00-16.30 น.<br />
                                    ค่าเข้าชมเพียง 20 บาท สำหรับชาวไทย
                                </p>
                                <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
                                    <a href="/contact" style={{
                                        backgroundColor: '#F45354',
                                        color: 'white',
                                        padding: '1rem 2rem',
                                        borderRadius: '50px',
                                        textDecoration: 'none',
                                        fontWeight: 'bold',
                                        fontSize: '1.5rem',
                                        transition: 'all 0.3s ease',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '0.5rem'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'translateY(-2px)';
                                        e.target.style.boxShadow = '0 6px 20px rgba(244, 83, 84, 0.4)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'translateY(0)';
                                        e.target.style.boxShadow = 'none';
                                    }}>
                                        จองเข้าชม
                                        <FiArrowRight />
                                    </a>
                                    <a href="/gallery" style={{
                                        backgroundColor: 'transparent',
                                        color: 'white',
                                        padding: '1rem 2rem',
                                        borderRadius: '50px',
                                        textDecoration: 'none',
                                        fontWeight: 'bold',
                                        fontSize: '1.5rem',
                                        border: '2px solid white',
                                        transition: 'all 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = 'white';
                                        e.target.style.color = '#242424';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = 'white';
                                    }}>
                                        ชมแกลเลอรี่
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                <Footer />
            </React.Fragment>
        )
    }
}

export default ExhibitionsAndActivities; 